import { Pagination, PaginationForm } from "./pagination.model";
import { SelectData } from "./select-input.model";

export interface User {
  id: number;
  primeiroNomeusuario: string;
  cpfcnpj: string;
  email: string;
}

export interface UserForm extends User {
  nomeUsuario: string;
  senha: string;
  repeatPassword: string;
  grupoUsuario: SelectData;
}

export interface ResetPassword {
  novaSenha: string;
  repetirSenha: string;
}

export interface ApplicationUser {
  id: number;
  email: string;
  senha: string;
  processoAutomatico?: string;
  tentativaLogin?: number;
  telefone?: string;
  atualizacaoCadastral?: boolean;
  autenticacao?: boolean;
  bloqueado?: boolean;
  dataNascimento?: string;
  ativo?: boolean;
  primeiroNomeusuario: string;
  nomemae?: string;
  nomeUsuario: string;
  ultimoNomeUsuario?: string;
  trocarSenha?: boolean;
  cpfcnpj: string;
  grupoUsuario: UserGroup;
}

export interface UserPaged extends Pagination {
  items: ApplicationUser[]
}

export interface UserFilter extends PaginationForm {
  search: string;
}

export interface UserGroup {
  id: number;
  nome: string;
  dataInativacao: Date;
  status: boolean;
}


export interface UserFilter extends PaginationForm {
  search: string;
}

export interface UserGroup {
  id: number;
  nome: string;
  dataInativacao: Date;
  status: boolean;
}
